import classNames from 'classnames'
import { HTMLInputTypeAttribute, useState } from 'react'
import { useField } from 'remix-validated-form'
import FormInputWrapper, { BaseInputClasses, FormInputWrapperProps } from './FormInputWrapper'
import { formatPhoneNumber } from 'app/formatPhoneNumber'

export type FormInputProps = {
  type?: HTMLInputTypeAttribute
  readOnly?: boolean
  readOnlyAsLabel?: boolean
  labelClassName?: string
  errorClassName?: string
  validateLength?: boolean
} & FormInputWrapperProps<HTMLInputElement>

export default function FormPhone({
  name,
  label,
  type = `text`,
  placeholder,
  readOnly,
  cols,
  readOnlyAsLabel,
  wrapperClassName,
  className,
  labelClassName,
  errorClassName,
  newLineError,
  showErrorIcon,
  validateLength = false,
  ...props
}: FormInputProps) {
  const { error, getInputProps } = useField(name)
  const [lengthError, setLengthError] = useState<string | undefined>()
  const inputClasses = classNames(
    className,
    BaseInputClasses,
    readOnly &&
      (readOnlyAsLabel
        ? `border-trn-200 shadow-elevation-1 read-only:cursor-not-allowed read-only:border-none read-only:p-0 read-only:shadow-none read-only:text-trn-500 read-only:focus:text-trn-500`
        : `border-trn-200 shadow-elevation-1 read-only:cursor-not-allowed read-only:border-gray-200 read-only:bg-trn-100 read-only:text-trn-500 read-only:focus:text-trn-500`),
  )

  let handleFormat = (event) => {
    let value = event.target.value
    event.target.value = formatPhoneNumber(value)

    if (validateLength) {
      const digitsOnly = value.replace(/\D/g, ``)
      if (digitsOnly.length > 0 && digitsOnly.length !== 10) {
        setLengthError(`Phone number must be 10 digits`)
      } else {
        setLengthError(undefined)
      }
    }
  }

  let displayError = error || lengthError

  return (
    <>
      <FormInputWrapper
        {...{
          name,
          label,
          error: displayError,
          showErrorIcon,
          newLineError,
          cols,
          wrapperClassName,
          className: labelClassName ?? `text-ui-sm`,
          errorClassName,
        }}
      >
        <input
          {...getInputProps({ ...props, type: `tel`, placeholder, readOnly: readOnly, onBlur: handleFormat })}
          className={inputClasses}
        />
      </FormInputWrapper>
    </>
  )
}
